import React, { useEffect, useState } from 'react';

import jackpotImageEmptyGrey from '@assets/images/coin-race/race/jackpot-empty-grey.png';
import jackpotImageEmpty from '@assets/images/coin-race/race/jackpot-empty.png';

import { getJackpotDigits, NUMBER_IMAGES_GREY, NUMBER_IMAGES, DIGITS_ARRAY } from './helper';
import * as Styled from './jackpot-counter.styled';

const DigitReel = ({ 
  targetDigit, 
  imagesMap, 
  delayIndex,
  isLeadingZero 
}: { 
  targetDigit: string | null, 
  imagesMap: Record<string, string>,
  delayIndex: number,
  isLeadingZero: boolean
}) => {
  const [activeDigit, setActiveDigit] = useState<number>(0);

  useEffect(() => {
    if (targetDigit === null) return;

    const parsedTarget = Number.parseInt(targetDigit, 10);
    const timer = setTimeout(() => {
      setActiveDigit(parsedTarget);
    }, 100);

    return () => clearTimeout(timer);
  }, [targetDigit]);

  if (targetDigit === null) {
    if (isLeadingZero) {
        return (
            <Styled.SlotWindow style={{ opacity: 0.5 }}>
                <Styled.ReelImage src={imagesMap['0']} alt="0" />
            </Styled.SlotWindow>
        )
    }
    return <Styled.SlotWindow style={{ visibility: 'hidden' }} />;
  }

  const duration = 1.5 + (delayIndex * 0.15); 
  const delay = 0; 

  return (
    <Styled.SlotWindow style={{ opacity: isLeadingZero ? 0.5 : 1 }}>
      <Styled.ReelStrip 
        $targetIndex={activeDigit} 
        $duration={duration}
        $delay={delay}
      >
        {DIGITS_ARRAY.map((digitKey) => (
          <Styled.ReelImage 
            key={digitKey} 
            src={imagesMap[digitKey]} 
            alt={digitKey} 
          />
        ))}
      </Styled.ReelStrip>
    </Styled.SlotWindow>
  );
};

type OwnProps = {
  amount: number;
  isCompleted?: boolean;
};

const JackpotCounter: React.FC<OwnProps> = ({ amount, isCompleted = false }) => {
  const imagesMap = isCompleted ? NUMBER_IMAGES_GREY : NUMBER_IMAGES;
  const bgImage = isCompleted ? jackpotImageEmptyGrey : jackpotImageEmpty;

  const digits = getJackpotDigits(amount);

  let isStillLeadingZero = true;

  return (
    <Styled.JackpotWrapper>
      <Styled.JackpotBg src={bgImage} alt="Jackpot Counter" />
      <Styled.DigitsContainer>
        {digits.map((digit, index) => {
          const isCurrentDigitLeadingZero = isStillLeadingZero && (digit === '0' || digit === null);
          
          if (digit !== '0' && digit !== null) {
            isStillLeadingZero = false;
          }

          return (
            <DigitReel 
              key={`reel-${index}`} 
              targetDigit={digit}
              imagesMap={imagesMap}
              delayIndex={index}
              isLeadingZero={isCurrentDigitLeadingZero} 
            />
          );
        })}
      </Styled.DigitsContainer>
    </Styled.JackpotWrapper>
  );
};

export default JackpotCounter;